export const ALLOWED_REQUEST_URL = ['accounts', 'address-book', 'vehicles', 'payment', 'tolling', 'activities', 'invoices', 'apimuser'];
